module.exports = __webpack_public_path__ + "static/img/yinghua_huang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/yinghua_huang.jpg
// module id = bONA
// module chunks = 0